import { CommonUtils } from "../../../util/common-utils";
import { ImageZoomForm } from "./image-zoom-form";
import { ImageZoomHandler } from "./image-zoom-handler";
import { ImageZoomListener } from "./image-zoom-listener";

/**
 * Image Zoom Setup (V2)
 * Entry point for cursor-follow magnifier behavior.
 */
export class ImageZoomSetup {
    public static init(scope: Document | HTMLElement = document): void {
        const zoomEnabled = ImageZoomSetup.getStoredZoomEnabled();
        const forceDisabledOnMobile = CommonUtils.isMobileViewport(768);

        ImageZoomForm.getRoots(scope).forEach((zoomRoot) => {
            if (forceDisabledOnMobile) {
                zoomRoot.dataset.imageZoomDisabled = "1";
                zoomRoot.dataset.imageZoomActive = "0";
            }

            if (
                !forceDisabledOnMobile &&
                zoomRoot.dataset.imageZoomDisabled !== "0" &&
                zoomRoot.dataset.imageZoomDisabled !== "1"
            ) {
                zoomRoot.dataset.imageZoomDisabled = zoomEnabled ? "0" : "1";
            }

            if (zoomRoot.dataset.imageZoomActive !== "0" && zoomRoot.dataset.imageZoomActive !== "1") {
                zoomRoot.dataset.imageZoomActive = "0";
            }

            const form = new ImageZoomForm(zoomRoot);
            if (form.isInitialized()) return;
            if (!(form.getSource() instanceof HTMLElement) || !(form.getTarget() instanceof HTMLElement)) return;

            const handler = new ImageZoomHandler(form);
            const listener = new ImageZoomListener(form, handler);

            handler.bootstrap();
            listener.register();
            form.markInitialized();
        });
    }

    public static getStoredZoomEnabled(): boolean {
        try {
            return globalThis.localStorage?.getItem("ui.productImageZoomEnabled") === "1";
        } catch {
            return false;
        }
    }
}
